module.exports = __webpack_public_path__ + "static/media/discover-electric-vehicles.c55157b7.svg";